import translations from './translations';

/**
 * Return the status label of the pick list.
 * @returns {string}
 */
export const getStatusLabel = (handlingList, intl) => {
  if (handlingList.is_in_progress) {
    return intl.formatMessage(translations.status.inProgress);
  }

  if (handlingList.is_on_hold) {
    return intl.formatMessage(translations.status.onHold);
  }

  if (handlingList.is_finished) {
    return intl.formatMessage(translations.status.finished);
  }

  return '-';
};

export default getStatusLabel;
